import { Machine } from 'xstate';
import { ProjectModule } from '@/store/modules/project.module';
// Handles
// a. Default Loads and Loading on transitions
// b. Tracking operation mode
// c. Composing objects for save or providing selected combos
const projectTaskPickerMachine = Machine({
    id: 'projectTaskPickerMachineId',
    initial: 'gettingRecentCombos',
    context: {
        operationMode: 0,
    },
    on: {
        GOTOTAB: [{
                target: 'gettingRecentCombos', cond: (ctx, event) => event.value === 0
            },
            {
                target: 'gettingProjectsForSelection', cond: (ctx, event) => event.value === 1
            },
            {
                target: 'readyForCreation', cond: (ctx, event) => event.value === 2
            }
        ]
    },
    states: {
        gettingRecentCombos: {
            invoke: {
                id: 'fetchRecentCombos',
                src: (_, __) => ProjectModule.GetTopTenProjectTaskCombosForSelection(),
                onDone: { target: 'recentCombosLoaded' },
                onError: { target: 'serviceUnavailable' }
            },
        },
        recentCombosLoaded: {},
        gettingProjectsForSelection: {
            invoke: {
                id: 'fetchProjectsForSelection',
                src: (_, __) => ProjectModule.GetProjectsForSelection(),
                onDone: { target: 'projectsLoaded' },
                onError: { target: 'serviceUnavailable' }
            },
        },
        projectsLoaded: {
            on: {
                FETCH_TASKS: { target: 'gettingTasksForSelection' },
            }
        },
        gettingTasksForSelection: {
            invoke: {
                id: 'fetchTasksForSelection',
                src: (_, __) => ProjectModule.GetTasksForSelection(__.projectId),
                onDone: { target: 'tasksLoaded' },
                onError: { target: 'serviceUnavailable' }
            },
        },
        tasksLoaded: {
            on: {
                CHANGE_PROJECT: { target: 'gettingProjectsForSelection' },
                FETCH_TASKS: { target: 'gettingTasksForSelection' },
            }
        },
        readyForCreation: {
            entry: (_, __) => { ProjectModule.InitializeProjectTaskCombo(); },
        },
        serviceUnavailable: { type: 'final' },
    }
}, {
    actions: {},
    services: {
        delayedSuccess: (_, __) => new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({ result: true });
            }, 10000);
        }),
        delayedFailure: (_, __) => new Promise((resolve, reject) => {
            setTimeout(() => {
                reject({ result: false });
            }, 5000);
        })
    },
    activities: {},
});
export default projectTaskPickerMachine;
